/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Description_1Inputs */

const bn_about_description_1 = /** @type {(inputs: About_Description_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দ্রুত দেশের স্বীকৃতির জন্য একটি বিশ্ব-প্রথম ভূগোল খেলা।`)
};

const de_about_description_1 = /** @type {(inputs: About_Description_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein weltweit einzigartiges Geografiespiel zur schnellen Ländererkennung.`)
};

const el_about_description_1 = /** @type {(inputs: About_Description_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ένα παιχνίδι γεωγραφίας για πρώτη φορά στον κόσμο για γρήγορη αναγνώριση χωρών.`)
};

const en_about_description_1 = /** @type {(inputs: About_Description_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A globe-first geography game for fast country recognition.`)
};

const es_about_description_1 = /** @type {(inputs: About_Description_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un juego de geografía pionero en el mundo para un rápido reconocimiento de países.`)
};

const fr_about_description_1 = /** @type {(inputs: About_Description_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un jeu de géographie centré sur le globe pour reconnaître rapidement les pays.`)
};

const hi_about_description_1 = /** @type {(inputs: About_Description_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तेजी से देश की पहचान के लिए विश्व-प्रथम भूगोल खेल।`)
};

const hu_about_description_1 = /** @type {(inputs: About_Description_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A világelső földrajzi játék a gyors országfelismeréshez.`)
};

const id_about_description_1 = /** @type {(inputs: About_Description_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game geografi pertama di dunia untuk pengenalan negara dengan cepat.`)
};

const it_about_description_1 = /** @type {(inputs: About_Description_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un primo gioco di geografia mondiale per il riconoscimento rapido del paese.`)
};

const ja_about_description_1 = /** @type {(inputs: About_Description_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`国を素早く認識できる、世界初の地理ゲーム。`)
};

const ko_about_description_1 = /** @type {(inputs: About_Description_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빠른 국가 인식을 위한 세계 최초의 지리 게임입니다.`)
};

const nl_about_description_1 = /** @type {(inputs: About_Description_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een wereldprimeur aardrijkskundespel voor snelle landherkenning.`)
};

const pl_about_description_1 = /** @type {(inputs: About_Description_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pierwsza na świecie gra geograficzna umożliwiająca szybkie rozpoznawanie krajów.`)
};

const pt_about_description_1 = /** @type {(inputs: About_Description_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um jogo geográfico pioneiro no mundo para reconhecimento rápido do país.`)
};

const ru_about_description_1 = /** @type {(inputs: About_Description_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Первая в мире географическая игра для быстрого распознавания страны.`)
};

const sv_about_description_1 = /** @type {(inputs: About_Description_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ett världsförsta geografispel för snabbt landigenkänning.`)
};

const tr_about_description_1 = /** @type {(inputs: About_Description_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hızlı ülke tanıma için dünyada bir ilk olan coğrafya oyunu.`)
};

const uk_about_description_1 = /** @type {(inputs: About_Description_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перша в світі географічна гра для швидкого розпізнавання країни.`)
};

const vi_about_description_1 = /** @type {(inputs: About_Description_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trò chơi địa lý đầu tiên trên thế giới giúp nhận dạng quốc gia nhanh chóng.`)
};

const zh_about_description_1 = /** @type {(inputs: About_Description_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全球首款地理游戏，可快速识别国家/地区。`)
};

const zh_hant_about_description_1 = /** @type {(inputs: About_Description_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全球首款地理遊戲，可快速識別國家。`)
};

/**
* | output |
* | --- |
* | "A globe-first geography game for fast country recognition." |
*
* @param {About_Description_1Inputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const about_description_1 = /** @type {((inputs?: About_Description_1Inputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Description_1Inputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_about_description_1(inputs)
	if (locale === "de") return de_about_description_1(inputs)
	if (locale === "el") return el_about_description_1(inputs)
	if (locale === "en") return en_about_description_1(inputs)
	if (locale === "es") return es_about_description_1(inputs)
	if (locale === "fr") return fr_about_description_1(inputs)
	if (locale === "hi") return hi_about_description_1(inputs)
	if (locale === "hu") return hu_about_description_1(inputs)
	if (locale === "id") return id_about_description_1(inputs)
	if (locale === "it") return it_about_description_1(inputs)
	if (locale === "ja") return ja_about_description_1(inputs)
	if (locale === "ko") return ko_about_description_1(inputs)
	if (locale === "nl") return nl_about_description_1(inputs)
	if (locale === "pl") return pl_about_description_1(inputs)
	if (locale === "pt") return pt_about_description_1(inputs)
	if (locale === "ru") return ru_about_description_1(inputs)
	if (locale === "sv") return sv_about_description_1(inputs)
	if (locale === "tr") return tr_about_description_1(inputs)
	if (locale === "uk") return uk_about_description_1(inputs)
	if (locale === "vi") return vi_about_description_1(inputs)
	if (locale === "zh") return zh_about_description_1(inputs)
	return zh_hant_about_description_1(inputs)
});